// extracted by mini-css-extract-plugin
export default {"animated_tr":"TableLoader_animated_tr__P6tQ5","loadingAnimation":"TableLoader_loadingAnimation__BfH6L"};